import Form, { FormField } from '@thinknimble/tn-forms'
import { RequiredValidator } from '@thinknimble/tn-forms/lib/validators'

export class FontForm extends Form {
  static name = new FormField({ validators: [new RequiredValidator()] })
  static style = new FormField({ validators: [new RequiredValidator()], default: 'body' })
  static file = new FormField({ validators: [new RequiredValidator()] })
}
